export const unknown = '예기치 못한 오류입니다. 잠시후 다시 시도해주세요.'
export const notFound = '존재하지 않는 페이지 입니다.'
export const server = '예기치 못한 서버 오류 입니다. 잠시후 다시 시도해주세요.'
